
<template>
  <!--采集设备-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="cdId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_deviceMark" slot-scope="{row}">
        <a-tooltip>
          <template slot="title">{{row.deviceMark}}</template>
          <div class="over-text-width">{{row.deviceMark}}</div>
        </a-tooltip>
      </template>

      <template slot="opt_isAlive" slot-scope="{row}">
        <a-row v-if="row.isAlived !== null" type="flex" align="middle" style="width: 60px">
          <a-col :class="[row.isAlived === 1 ? 'success-bg' : 'danger-bg', 'circle-dot']"></a-col>
          <span>{{row.isAlived === 1 ? '成功' : '失败'}}</span>
        </a-row>
      </template>

      <template slot="opt_pushStatus" slot-scope="{row}">
        <a-row v-if="row.pushStatus !== null" type="flex" align="middle" style="width: 60px">
          <a-col :class="[row.pushStatus === 1 ? 'success-bg' : 'danger-bg', 'circle-dot']"></a-col>
          <span>{{row.pushStatus === 1 ? '成功' : '失败'}}</span>
        </a-row>
      </template>

      <template slot="opt_lastPushTime" slot-scope="{row}">
<!--        <a-button type="link" @click="showPushLog(row)">{{row.lastPushTime}}</a-button>-->
        <span>{{row.lastPushTime}}</span>
      </template>
    </x-tabula>

    <!--新增采集设备的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @cancel="visible=false"
      v-bind="$store.state.modalConfig"
      :footer="null"
    >
      <x-addEdit
        ref="addEdit"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
      </x-addEdit>
    </a-modal>

    <!--历史推送的弹窗-->
    <a-modal
      title="查看历史推送时间"
      :visible="pushLogVisible"
      @cancel="pushLogVisible=false"
      :width="600"
      :footer="null"
      v-bind="$store.state.modalConfig"
    >
      <x-tabula
        rowKey="pushId"
        :searchParams="pushLogParams"
        :columns="pushLogColumns"
        :listApi="pushLogApi"
        :rowSelection="false"
      />
    </a-modal>
  </div>
</template>

<script>
import addDevice from './addDevice';
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'collectDevice',
  mixins: [addDevice, fetchSelect],
  data () {
    return {
      visible: false,
      modalTitle: '新增采集设备',
      cityList: [],
      deviceTypeList: [],

      pushLogVisible: false,
      pushLogParams: { cdId: undefined },
      pushLogApi: {
        url: '/coll/device/pushLog',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      pushLogColumns: [
        { title: '状态', dataIndex: 'statusDesc', align: '', width: '' },
        { title: '注册时间', dataIndex: 'pushTime', align: '', width: '' }
      ],

      searchParams: {
        areas: undefined,
        csId: undefined,
        deviceMark: undefined,
        nationalId: undefined,
        deviceCode: undefined,
        deviceName: undefined,
        deviceType: undefined,
        isAlived: undefined,
        pushStatus: undefined,
        pushTime: undefined
      },
      searchList: [
        { props: ['areas'], placeholder: '城市', options: [], inputType: 'cascader', handle: e => this.cityChange(e, 'searchList', 1) },
        { props: ['csId'], placeholder: '系统名称', options: [], inputType: 'select' },
        { props: ['deviceMark'], placeholder: '采集设备信息标识', options: [], inputType: 'input' },
        { props: ['nationalId'], placeholder: '国标ID', options: [], inputType: 'input' },
        { props: ['deviceCode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['deviceName'], placeholder: '设备名称', options: [], inputType: 'input' },
        { props: ['deviceType'], placeholder: '设备类型', options: [], inputType: 'select' },
        { props: ['isAlived'], placeholder: '保活状态', options: this.$store.state.isSuccessList, inputType: 'select' },
        { props: ['pushStatus'], placeholder: '推送状态', options: this.$store.state.isSuccessList, inputType: 'select' },
        { props: ['pushTime'], placeholder: ['推送时间', '推送时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:collectDevice:add'] },
        { text: '导入', icon: 'cloud-upload', handle: () => this.$router.push({name: 'importDev'}), permi: ['community:collectDevice:import'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:collectDevice:delete'] }
      ],
      rowOptList: [
        {
          text: '修改',
          handle: row => this.toEdit(row), // 处理方法
          permi: ['community:collectDevice:edit']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          rowOptDisHandle: row => false, // 禁用按钮
          permi: ['community:collectDevice:delete']
        }
      ],
      columns: [
        { title: '城市', dataIndex: 'cityName', align: '', width: '' },
        { title: '系统名称', dataIndex: 'systemName', align: '', width: '' },
        { title: '采集设备信息标识', dataIndex: 'deviceMark', align: '', width: '', scopedSlots: {customRender: 'deviceMark'} },
        { title: '国标ID', dataIndex: 'nationalId', align: '', width: '' },
        { title: '设备编码', dataIndex: 'deviceCode', align: '', width: '' },
        { title: '设备名称', dataIndex: 'deviceName', align: '', width: '' },
        { title: '设备类型', dataIndex: 'deviceTypeDesc', align: '', width: '' },
        { title: '保活状态', dataIndex: 'isAlived', align: '', width: '', scopedSlots: {customRender: 'isAlive'} },
        { title: '推送状态', dataIndex: 'pushStatus', align: '', width: '', scopedSlots: {customRender: 'pushStatus'} },
        { title: '最近推送时间', dataIndex: 'lastPushTime', align: '', width: '175px', scopedSlots: {customRender: 'lastPushTime'} },
        { title: '操作', dataIndex: 'action', align: '', width: '100px', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/coll/device/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '/coll/device/delete/',
        title: '采集设备',
        key: 'deviceName',
        resHandle: this.delResHandle // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.provinceCitySelect(data => {
        this.searchList[0].options = data;
        this.cityList = data;
      });

      this.$get({
        url: '/coll/device/getDeviceType',
        params: {}
      }).then(({ data }) => {
        this.searchList[6].options = data;
        this.deviceTypeList = data;
      });

      this.getSystemName(undefined, 1);
    },
    /** 获取系统名称下拉 */
    getSystemName (id, index) {
      this.$get({
        url: '/coll/device/getCollSystem',
        params: { cityId: id }
      }).then(({ data }) => {
        this.searchList[index].options = data;
      });
    },
    delResHandle () {
      this.getSystemName(undefined, 1);
    },
    /** 查看推送日志 */
    showPushLog (row) {
      this.pushLogParams.cdId = row.cdId;
      this.pushLogVisible = true;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
